import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Login from "./pages/Login/Login";
import Status from "./pages/Status/StatusPage";
import Pedido from "./pages/Pedido/PedidoPage";

import AdminPage from "./pages/Admin/Admin";
import Dashboard from "./pages/Dashboard/Dashboard";
import DashboardTotal from "./pages/Dashboard/DashboardTotal";
import DashboardTotalReposicao from "./pages/Dashboard/DashboardTotalReposicao";
import DashboardTotalInseridos from "./pages/Dashboard/DashboardTotalInseridos";





import Provedores from "./pages/Provedores/Provedores";
import NewProvedor from "./pages/NewProvedor/NewProvedor";


function App() {
   const location = useLocation();
 

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/status" element={<Status />} />
      <Route path="/pedido" element={<Pedido />} />

      <Route path="/adminseja" element={<AdminPage />} />
      <Route path="/provedores" element={<Provedores />} />
      <Route path="/new_provedores" element={<NewProvedor />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/total_pedidos" element={<DashboardTotal />} />
      <Route path="/total_reposicao" element={<DashboardTotalReposicao />} />
      <Route path="/total_inseridos" element={<DashboardTotalInseridos />} />

      
      
      
    </Routes>
  );
}
export default App;
